export const NAMESPACE = 'AB_TESTING/';

export const SET_SOURCE = NAMESPACE + 'SET_SOURCE';
export const SET_PARTS_COUNT = NAMESPACE + 'SET_PARTS_COUNT';
export const SET_SHUFFLE = NAMESPACE + 'SET_SHUFFLE';
